import { PopupModal, useCalendlyEventListener } from 'react-calendly';
import { logEvent } from '../lib/analytics';

const calendlyModalElement =
  typeof window !== 'undefined' && document.getElementById('__next');

interface CalendlyModalProps {
  calendlyModalUri: string | undefined;
  onClose: () => void;
}

export const CalendlyModal: React.FC<CalendlyModalProps> = ({
  calendlyModalUri,
  onClose,
}) => {
  useCalendlyEventListener({
    onProfilePageViewed: () =>
      logEvent({ category: 'Calendly Modal', name: 'Profile Page Viewed' }),
    onEventTypeViewed: () =>
      logEvent({ category: 'Calendly Modal', name: 'Event Type Viewed' }),
    onDateAndTimeSelected: () =>
      logEvent({ category: 'Calendly Modal', name: 'Date and Time Selected' }),
    onEventScheduled: () =>
      logEvent({ category: 'Calendly Modal', name: 'Event Scheduled' }),
  });

  return calendlyModalElement ? (
    <PopupModal
      url={calendlyModalUri ?? ''}
      onModalClose={onClose}
      open={!!calendlyModalUri}
      rootElement={calendlyModalElement}
      pageSettings={{ hideGdprBanner: true }}
    />
  ) : null;
};
